import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../lib/bemUtils/Modifier';
import bem from '../../lib/bemUtils/bem';

type HTMLFormProps = React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>;

export enum Form2Modifier {
  NO_PADDING = 'no-padding',
  NO_PADDING_BOTTOM = 'no-padding-bottom',
}

type Form = PropsWithChildren<{
  modifier?: Modifier<Form2Modifier>;
  ref?: React.Ref<HTMLFormElement>;
}> &
  Omit<HTMLFormProps, 'className'>;

export function Form({ modifier, children, ref, ...htmlFormProps }: Form) {
  return (
    <form {...htmlFormProps} ref={ref} className={bem('form2', modifier)}>
      {children}
    </form>
  );
}
